import { isNullOrUndefined } from '@app/util/util';
import isEmpty from 'lodash-es/isEmpty';

import { AssetBanks } from '@asset-banks';
import { AssetCards } from '@asset-cards';
import { Card, MinPriceExceptionCardInterface } from '@app/entities/cards';
import { Bank, MinPriceExceptionBankInterface } from '@app/entities/banks';

export const ALL_CARDS: Card[] = (AssetCards?.cards || []).filter((item: Card) => !item.disabled);

export const CARD_EXCEPTIONS: MinPriceExceptionCardInterface =
  AssetCards?.min_price_cards_exception || {} as MinPriceExceptionCardInterface;

export const ALL_BANKS: Bank[] = (AssetBanks?.banks || []).filter((item: Bank) => !item.disabled);

export const BANK_EXCEPTIONS: MinPriceExceptionBankInterface =
  AssetBanks?.min_price_banks_exception || {} as MinPriceExceptionBankInterface;

export function cardsPartnerCollection(totalPrice: number): Card[] {
  return ALL_CARDS.filter((item: Card, index: number) => isValidCardByTotalPrice(index, totalPrice));
}

export function banksPartnerCollection(totalPrice: number): Bank[] {
  return ALL_BANKS.filter((item: Bank, index: number) => isValidBankByTotalPrice(index, totalPrice));
}

function isValidCardByTotalPrice(index: number, price: number): boolean {
  if (
    !isNullOrUndefined(price) &&
    validCardExceptionsByGrid(index)
  ) {
    return price >= CARD_EXCEPTIONS.card_items_min_price;
  } else return true;
}

function validCardExceptionsByGrid(index: number): boolean {
  return !isEmpty(CARD_EXCEPTIONS) &&
    !isNullOrUndefined(CARD_EXCEPTIONS?.card_items_min_price) &&
    !!CARD_EXCEPTIONS?.card_items?.length &&
    !!CARD_EXCEPTIONS?.card_items?.includes(index);
}

function isValidBankByTotalPrice(index: number, price: number): boolean {
  if (
    !isNullOrUndefined(price) &&
    validBankExceptionsByGrid(index)
  ) {
    return price >= BANK_EXCEPTIONS.bank_items_min_price;
  } else return true;
}

function validBankExceptionsByGrid(index: number): boolean {
  return !isEmpty(BANK_EXCEPTIONS) &&
    !isNullOrUndefined(BANK_EXCEPTIONS?.bank_items_min_price) &&
    !!BANK_EXCEPTIONS?.bank_items?.length &&
    !!BANK_EXCEPTIONS?.bank_items?.includes(index);
}
